import React from 'react';
import List, { defaultFilters } from '../../cruds/List';
import Edit from '../../cruds/Edit';
import { stringNotBlank } from '../../cruds/validators';
import Table, { Column } from '../../components/container/Table';
import { EditButton, DeleteButton } from '../../components/output/CrudButton';
import OutputValue from '../../components/output/OutputValue';
import InputText from '../../components/input/InputText';
import MainContainer from '../../components/MainContainer';
import { Switch, Route } from 'react-router-dom';
import WithRole, { withRoles } from '../../components/container/WithRole';

const ENTITY_NAME = 'companies';
const TITLE = 'companies.title';

const CrudEdit = props => {
  const validators = [
    stringNotBlank('name', 'companies.err.name'),
  ];
  return (
    <Edit {...props}
        title={TITLE}
        entityName={ENTITY_NAME}
        entityRoute={ENTITY_NAME}
        entityId={props.match.params.number}
        validators={validators}
    >
      <InputText name="name" label="companies.name" required />
    </Edit>
  );
};

const CrudList = props => {
  const table = <Table>
                  <Column label="companies.name" orderingName="NAME">
                    <OutputValue name="name" />
                  </Column>
                  <Column>
                    <WithRole roles={['A', 'B']}>
                      <EditButton entityRoute={props.match.url} />
                    </WithRole>
                    <WithRole roles={['A', 'B']}>
                      <DeleteButton />
                    </WithRole>
                  </Column>
                </Table>;

  return <List title={TITLE}
                entityName={ENTITY_NAME}
                entityRoute={ENTITY_NAME}
                component={table}
                filters={defaultFilters()}
                defaultOrdering="NAME"
                hideAddButton = {!withRoles(['A', 'B'])}
          />;
};

const Companies = props => {
  const basePath = props.match.url;
  return (
    <MainContainer>
      <Switch>
        <Route exact path={basePath} component={CrudList} />
        <Route exact path={basePath + '/edit/:number'} render={props => <CrudEdit {...props} />} />
        <Route exact path={basePath + '/add'} render={props => <CrudEdit {...props} />} />
      </Switch>
    </MainContainer>
  );
};

export default Companies;



// WEBPACK FOOTER //
// ./src/main/pages/registry/Companies.js